<template>
  <div class="about">
    <div class="banner">
      <img :src="$store.state.isMB?'static/mbimages/about/banner.jpg':'static/images/about/about_banner.png'" alt="">
      <div class="textNtitle">
        <div class="banner_title">关于东升</div>
        <div class="banner_text">国内深耕多领域的行业信息数据及系统解决方案服务商</div>
      </div>
    </div>
    <div class="introduceUs">
      <div class="history">
          <div v-for="item in hisList" :key="item.main">
              <span class="years">{{item.years}}</span><span class="more">{{item.more || ' '}}</span>年<br>
              <span class="main">{{item.main}}</span>
          </div>
      </div>
      <img width="100%" :src="$store.state.isMB?'static/mbimages/about/bg1.jpg':'static/images/about/about_bg1.png'" alt="">
      <div class="info_title">
        <span>关于我们</span>
      </div>
      <div class="aboutUs">广东东升信息技术有限公司（东升信息）成立于1997年，是深耕数据中心、云与大数据领域，具备全链条交付能力的IT综合服务提供商，是国家高新技术企业，总部设于汕头，在北京、广州设有子公司，多个地市设有办事处。
        <br>东升公司起步于汽车后市场，经营零配件贸易、保险公估、零配件回收与再制造等实体服务。在发展过程中，企业快速洞察行业趋势，快速发展软件研发能力，并发展成为涵盖业务平台建设、数据、业务咨询分析，专业培训一体化的服务提供商，与国内大型保险公司有广泛深入合作，长期服务国内多家大型保险公司，积累稳定行业合作基础与客户认可。
        <br><br class="mbchangeLine">2016年开始，东升自研开发平台，以高效、经济、安全为核心理念搭建标准化统一开发流程，实现平台资产化管理构建。目前该平台应用于包括保险、汽车后市场等领域。
      </div>
      <div class="info_title mission">
        <span>我们的使命</span>
      </div>
      <div class="purpose">
          <div class="content" v-for="item in purList" :key="item.title">
            <div class="center">
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.text}}</div>
            </div>
          </div>
      </div>
      <div class="info_title business">
        <span>公司业务</span>
      </div>
      <div class="business_text">现有四大板块业务，包括数据中心服务业务、云计算SaaS业务、大数据服务业务、行业应用服务业务。长期服务政府行业和保险行业、汽车后市场行业，已完成产业数据与空间信息服务平台建设，实现自主投资、自主建设、自主管理、自主运营；平台在架构设计上注重系统稳定性、信息安全防护与绿色节能设计。
        <br>廿余年以来，东升信息以数据中心为基础，以符合国际和国家规范标准的运行管理体系和专业的服务团队为支撑，在保险金融行业、汽车领域数据产业、地理信息GIS领域及产业物联网领域，以云计算、大数据、移动互联网的应用做增值服务。
      </div>
      <div class="business_detail">
        <div v-for="(item,index) in detailList" class="detail"
        :class="showDetail==index?'showDetail':''"
        :key="item.title" @mouseenter="detailChange(index)">
          <img :src="item.url" alt="" :style="showDetail==index&&!$store.state.isMB?keepCenter(index):''">
          <div class="title">{{item.title}}</div>
          <ul>
            <li><div></div>{{item.detail_text1}}<br v-if="item.tip1"><span>{{item.tip1}}</span></li>
            <li><div></div>{{item.detail_text2}}<br v-if="item.tip2"><span>{{item.tip2}}</span></li>
            <li v-if="item.detail_text3"><div></div>{{item.detail_text3}}<br v-if="item.tip3"><span>{{item.tip3}}</span></li>
            <li v-if="item.detail_text4"><div></div>{{item.detail_text4}}</li>
          </ul>
        </div>
      </div>
      <div class="info_title link">
        <span>联系我们</span>
      </div>
      <div class="ourMsg">
        <div class="branch" v-for="msg in msgList" :key="msg.name">
            <img :src="msg.url" alt="">
            <div class="name">{{msg.name}}</div>
            <div class="address">{{msg.address}}</div>
            <span class="call">{{msg.call}}</span>
            <span class="other" v-if="msg.other">{{msg.other}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      hisList: [
        { main: '创始于1997年', years: '20', more: '+' },
        { main: '汽车后市场', years: '20', },
        { main: '保险行业', years: '15', },
        { main: '互联网科技行业', years: '10', }
      ],
      purList: [
        { title: '共赢', text: '构建扎实的技术与产品研发能力' },
        { title: '共生', text: '为客户提供可持续性成长动力' },
        { title: '共荣', text: '寻求构建行业良好生态体系建设' }
      ],
      detailList: [
        { title: '配件供应链', url: 'static/images/about/yw1icon.png', detail_text1: '1997年开始从事汽车维修和配件供应服务至今', detail_text2: '保险事故件、认证件供应链' },
        { title: '保险第三方服务', url: 'static/images/about/yw4icon.png', detail_text1: '保险案件风险审核', detail_text2: '零配件报价服务', detail_text3: '车险损失评估', detail_text4: '旧件回收与修复服务' },
        { title: '信息及电商平台', url: 'static/images/about/yw5icon.png', detail_text1: '汽配平台', detail_text2: '整车拍卖平台' }
      ],
      showDetail: 1,
      msgList: [
        { name: '汕头 | 总部', url: 'static/images/about/st.png', address: '广东省汕头市高新区科技东路7号12层', call: '0754 - 88168168 / 88268886', other: 'kf@eccc.cc' },
        { name: '北京', url: 'static/images/about/bj.png', address: '北京市东三环中路39号建外SOHO东区', call: '010 - 59009215' }
        // { name: '广州', url: 'static/images/about/gz.png', address: '广州市广园东路2193号时代新世界中心北塔2601室', call: '020 - 22822210' }
      ]
    }
  },
  methods: {
    detailChange (n) {
      this.showDetail = n
    },
    keepCenter (index,n) {
      switch (index) {
        case 0:
            return 'margin-top: 132px;'
        case 1:
            return 'margin-top: 78px;'
        case 2:
            return 'margin-top: 111.5px;'
        case 3:
            return 'margin-top: 90.5px;'
        case 4:
            return 'margin-top: 131px;'
      }
    }
  },
  mounted () {
      window.scroll(0,0)
  }
}
</script>
<style lang="scss">
.about{
  .banner{
    .banner_title,.banner_text{
      width: fit-content;
    }
    .banner_text{
      font-size: 22px;
      margin-top: 12px;
      @media screen and (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
  .introduceUs{
    width: 1200px;
    margin: auto;
    @media screen and (max-width: 767px) {
      width: 100%;
    }
    .history{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      @media screen and (max-width: 767px) {
        padding-top: 50px;
      }
      & > div {
        text-align: center;
        color: #333;
        height: 228px;
        padding-top: 56px;
        @media screen and (max-width: 767px) {
          position: relative;
          width: 40%;
          height: 17.87vw;
          padding: 0;
          margin-bottom: 60px;
        }
      }
      .years{
        font-size: 64px;
        font-weight: bold;
        line-height: 90px;
        @media screen and (max-width: 767px) {
          font-size: 44px;
          line-height: 60px;
        }
      }
      .main{
        font-size: 18px;
        @media screen and (max-width: 767px) {
          font-size: 16px;
        }
      }
      .more{
        font-size: 36px;
        vertical-align: 30px;
        @media screen and (max-width: 767px) {
          font-size: 26px;
          vertical-align: 20px;
        }
      }
    }
    .info_title{
      width: 170px;
      margin-top: 47px;
      @media screen and (max-width: 767px) {
        width: 140px;
      }
    }
    .link{
      @media screen and (min-width: 768px) {
        margin-top: 60px;
      }
    }
    .mission{
      width: 207px;
      margin-top: 36px;
      @media screen and (max-width: 767px) {
        width: 160px;
      }
    }
    .aboutUs{
      line-height: 32px;
      font-size: 16px;
      margin-top: 46px;
      @media screen and (max-width: 767px) {
        padding: 0 4%;
      }
    }
    .purpose{
      display: flex;
      margin-top: 68px;
      @media screen and (max-width: 767px) {
        padding: 0 4%;
        flex-wrap: wrap;
      }
      .content {
        width: 400px;
        height: 400px;
        padding-top: 150px;
        @media screen and (max-width: 767px) {
          width: 100%;
          height: 55.07vw;
          padding-top: 16.08vw;
          margin-bottom: 30px;
        }
        .center{
          height: 100px;
          width: 300px;
          background: rgba(41,54,115,0.35);
          color: #fff;
          text-align: center;
          padding-top: 15px;
          margin: auto;
          @media screen and (max-width: 767px) {
            width: 68.7%;
            height: 100px;
          }
          .title{
            font-size: 26px;
            line-height: 32px;
            @media screen and (max-width: 370px) {
              font-size: 22px;
              line-height: 22px;
            }
          }
          .text{
            margin-top: 10px;
            line-height: 32px;
            @media screen and (max-width: 767px) {
              margin-top: 1%;
            }
            @media screen and (max-width: 370px) {
              font-size: 14px;
              margin-top: 3%;
            }
          }
        }
      }
      .content:nth-of-type(1) {
        background: url('../../../static/images/about/sm1.png') no-repeat;
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/sm1.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
      .content:nth-of-type(2) {
        background: url('../../../static/images/about/sm2.png') no-repeat;
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/sm2.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
      .content:nth-of-type(3) {
        background: url('../../../static/images/about/sm3.png') no-repeat;
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/sm3.jpg') no-repeat;
        }
        background-size: 100% 100%;
      }
    }
    .business{
      width: 170px;
      @media screen and (max-width: 767px) {
        width: 140px;
        margin-top: 20px;
      }
    }
    .business_text{
      line-height: 32px;
      font-size: 16px;
      margin-top: 46px;
      @media screen and (max-width: 767px) {
        padding: 0 4%;
        margin-top: 35px;
      }
    }
    .business_detail{
      display: flex;
      margin-top: 69px;
      @media screen and (max-width: 767px) {
        flex-direction: column;
        padding: 0 4%;
      }
      .detail {
        width: 174px;
        height: 500px;
        transition-duration: 0.5s;
        text-align: center;
        @media screen and (max-width: 767px) {
          width: 100%;
          height: 29vw;
          text-align: left;
        }
        .title{
          font-size: 24px;
          color: #fff;
          line-height: 48px;
          width: 120px;
          margin: 33px auto 0;
          @media screen and (max-width: 767px) {
            display: inline;
            vertical-align: -4.5vw;
            font-size: 18px;
          }
        }
        img {
          margin-top: 154.5px;
          @media screen and (max-width: 767px) {
            width: 52px;
            margin: 8vw 4vw 0 6vw;
          }
        }
        ul {
          color: #fff;
          visibility: hidden;
          margin-top: 29px;
          text-align: left;
          padding-left: 40px;
          @media screen and (max-width: 767px) {
            padding: 0 4% 0 6%;
          }
          li {
            list-style: none;
            margin-bottom: 19px;
            @media screen and (max-width: 767px) {
              font-size: 14px;
            }
            span {
              margin-left: 26px;
              @media screen and (max-width: 767px) {
                margin-left: 18px;
              }
            }
            div {
              background: #d31521;
              height: 10px;
              width: 10px;
              border-radius: 50%;
              display: inline-block;
              margin-right: 1rem;
              @media screen and (max-width: 767px) {
                margin-right: 0.5rem;
              }
            }
          }
        }
      }
      .detail:nth-of-type(1){
        background: url('../../../static/images/about/yw1.png');
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/yw1.jpg');
        }
      }
      .detail:nth-of-type(2){
        background: url('../../../static/images/about/yw2.png');
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/yw2.jpg');
        }
        .title {
          margin-top: 36px;
        }
      }
      .detail:nth-of-type(3){
        background: url('../../../static/images/about/yw3.png');
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/yw3.jpg');
        }
        .title {
          margin-top: 36px;
        }
      }
      .detail:nth-of-type(4){
        background: url('../../../static/images/about/yw4.png');
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/yw4.jpg');
        }
      }
      .detail:nth-of-type(5){
        background: url('../../../static/images/about/yw5.png');
        @media screen and (max-width: 767px) {
          background: url('../../../static/mbimages/about/yw5.jpg');
        }
        .title {
          margin-top: 28px;
        }
      }
      .detail:nth-of-type(2),.detail:nth-of-type(4){
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
        @media screen and (max-width: 767px) {
          border-top: 1px solid #fff;
          border-bottom: 1px solid #fff;
          border-left: none;
          border-right: none;
        }
      }
      .showDetail{
        width: 500px !important;
        text-align: left;
        @media screen and (max-width: 767px) {
          height: fit-content !important;
          width: 100% !important;
          padding-bottom: 10px;
        }
        img {
          margin-left: 39px !important;
          @media screen and (max-width: 767px) {
            margin-left: 0x;
          }
        }
        .title{
          margin-left: 39px !important;
          width: fit-content;
          @media screen and (max-width: 767px) {
            margin-left: 0 !important;
          }
          @media screen and (max-width: 360px) {
            font-size: 16px;
          }
        }
        ul {
          transition-delay: 0.2s;
          visibility: visible;
        }
      }
    }
    .ourMsg{
      display: flex;
      // justify-content: space-between;
      text-align: center;
      padding-bottom: 80px;
      @media screen and (max-width: 767px) {
        display: block;
      }
      .branch{
        width: 275px;
        letter-spacing: 0;
        margin-right: 120px;
        @media screen and (max-width: 767px) {
          width: 53%;
          margin: auto;
        }
        img{
          box-shadow: 0 2px 6px rgba(29,35,41,0.12);
          margin: 65px 0 24px;
          border-radius: 50%;
          @media screen and (max-width: 767px) {
            margin: 40px 0 16px;
          }
        }
        .name {
          font-size: 24px;
          color: #333;
          margin-bottom: 24px;
          @media screen and (max-width: 767px) {
            margin-bottom: 12px;
          }
        }
        .address{
          color: #333;
          line-height: 32px;
          @media screen and (max-width: 767px) {
            line-height: 26px;
          }
        }
        .call,.other{
          color: #666;
          line-height: 32px;
          @media screen and (max-width: 767px) {
            line-height: 26px;
          }
        }
      }
      .branch:nth-of-type(3) {
        width: 280px;
        @media screen and (max-width: 767px) {
          width: 53%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comPages/about.vue